module.exports = __webpack_public_path__ + "static/media/horse.44070a48.svg";